import { useCallback, useEffect, useMemo, useState } from 'react';
import Modal from './Modal';
import OneBallotResource from '../resources/Ballot/One';
import { getIncompleteCategoryKeys } from '../resources/Ballot/services';
import ballotDisplayOrder from '../resources/Ballot/constants/ballotDisplayOrder';
import ObjectiveStateResource from '../resources/ObjectiveState';
import { ComposeBallotIndex } from './ComposeBallotIndex';
import { ComposeBallotFocusCategory } from './ComposeBallotFocusCategory';
import { CurrentUserMustResource } from '../resources/Auth/CurrentUserMust';

let ComposeBallotModal = ({
  isOpen,
  onClose,
  onCloseStart,
}: {
  isOpen: boolean;
  onClose: () => void;
  onCloseStart?: () => void;
}) => {
  let currentUser = CurrentUserMustResource.use();
  let ballot = OneBallotResource.use(currentUser.id);
  let { ballotShape } = ObjectiveStateResource.use();

  let [focusedBallotItemKey, setFocusedBallotItemKey] = useState<
    null | (typeof ballotDisplayOrder)[number]
  >(null);

  let incompleteCategoryKeys = getIncompleteCategoryKeys({
    ballot,
    ballotShape,
  });

  let nextIncompleteCategoryKey = useMemo(() => {
    let remainingKeys = incompleteCategoryKeys.filter(
      item => item !== focusedBallotItemKey,
    );
    return remainingKeys[0] || null;
  }, [focusedBallotItemKey, incompleteCategoryKeys]);

  // clear focused item after close modal
  useEffect(() => {
    if (isOpen) return;
    let timeout = setTimeout(() => {
      setFocusedBallotItemKey(null);
    }, 600);
    return () => {
      clearTimeout(timeout);
    };
  }, [isOpen]);

  let clearFocusedBallotItemKey = useCallback(() => {
    setFocusedBallotItemKey(null);
  }, [setFocusedBallotItemKey]);

  let onNavigateToNextIncomplete = useCallback(() => {
    setFocusedBallotItemKey(nextIncompleteCategoryKey);
  }, [nextIncompleteCategoryKey]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      onCloseStart={onCloseStart}
      onBack={focusedBallotItemKey ? clearFocusedBallotItemKey : undefined}
      disableBodyPadding
    >
      {focusedBallotItemKey ? (
        <ComposeBallotFocusCategory
          key={focusedBallotItemKey}
          ballotItemKey={focusedBallotItemKey}
          nextIncompleteCategoryKey={nextIncompleteCategoryKey || undefined}
          onNavigateToNextIncomplete={onNavigateToNextIncomplete}
          onNavigateBack={onClose}
        />
      ) : (
        <ComposeBallotIndex
          onFocusItem={(itemKey: (typeof ballotDisplayOrder)[number]) => {
            setFocusedBallotItemKey(itemKey);
          }}
        />
      )}
    </Modal>
  );
};

export default ComposeBallotModal;
